import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["magicLink", "password", "magicLinkEmail", "passwordEmail"]

  showPassword(event) {
    event.preventDefault()
    this.copyEmail(this.magicLinkEmailTarget, this.passwordEmailTarget)
    this.magicLinkTarget.style.display = "none"
    this.passwordTarget.style.display = ""
  }

  showMagicLink(event) {
    event.preventDefault()
    this.copyEmail(this.passwordEmailTarget, this.magicLinkEmailTarget)
    this.passwordTarget.style.display = "none"
    this.magicLinkTarget.style.display = ""
  }

  // Carry a typed email across the toggle so switching forms never loses it.
  // Only overwrite when the source has a value, so a server-prefilled
  // destination (e.g. params[:email_address]) isn't wiped by an empty source.
  copyEmail(source, target) {
    if (source?.value) target.value = source.value
  }
}
